<template>
  <div class="testPaper">
      <div class="textPater-header">
          <div class="page-module">
            <p>{{testPaperNavTititle}}</p>
          </div>
      </div>
      <div class="testPaper-main">
        <router-view />
      </div>
  </div>
</template>

<script>
import $ from 'jquery'
// import merge from 'webpack-merge'
export default {
    name: 'testPaper',
    data () {
        return {
            testPaperNavTititle: '',
        }
    },
    mounted () {
        // 隐藏导航栏
        $('.header').css('display','none')
        $('.footer').css('display','none')
        $('html').css('background', '#f8f8f8')

        // 路由参数存在时使用
        // if (this.$route.query.subject) {
        //     this.testPaperNavTititle = this.$route.query.subject
        // }
    },
    methods: {
        initTestPaperNavTitle(testPaperNavTititle) {   // 初始化导航名称
            // 增加路由参数
            // this.$router.push({
            //     query: merge(this.$route.query, {'subject': testPaperNavTititle})
            // })
            this.testPaperNavTititle = testPaperNavTititle
        },
        goRouyer() {    // 路由跳转
            this.$router.push({name: 'Index'})
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {},
    beforeDestroy() {
        // 显示导航栏
        $('.header').css('display','block')
        $('.footer').css('display','block')
        $('html').css('background', '#fff')
    }
}
</script>

<style lang="scss" type="text/scss" scope>
.testPaper {
    .textPater-header {
        position: fixed;
        z-index: 5;
        height: 50px;
        top: 0;
        left: 0;
        right: 0;
        background: #000;
        p {
            line-height: 50px;
            color: #E5E5E5;
            // cursor: pointer;
        }
    }
    .page-module {
        margin: auto;
        max-width: 1200px;
    }
    .testPaper-main {
        // margin-top: 80px;
    }
}
</style>